import React from "react";
import { Helmet } from "react-helmet-async";
import InnerBanner from "../components/InnerBanner";
import Services from "../components/Services";
import Faqs from "../components/Faqs";
import serviceBg from "../assets/hero3.png";
import "./Service.css";

const Service = () => {
  return (
    <>
      <Helmet>
        <title>Appliance Repair Services in Bangalore</title>
        <meta
          name="description"
          content="Book doorstep appliance repair services in Bangalore for washing machines, refrigerators, ACs, and more."
        />
        <link rel="canonical" href="https://customersupports24x7.in/services" />
      </Helmet>

      <InnerBanner title="Appliance Repair Services" bgImage={serviceBg} />
      <Services />
      <Faqs />
    </>
  );
};

export default Service;
